"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get UserLikeNLikeSqliteHandler () {
        return UserLikeNLikeSqliteHandler;
    },
    get UserSqliteHandler () {
        return UserSqliteHandler;
    }
});
const _sqlite3 = require("src/db/aggregations/sqlite3");
const _genericsqlite = require("../generic.sqlite");
const _usergeneralhandler = require("./user.general.handler");
let UserLikeNLikeSqliteHandler = class UserLikeNLikeSqliteHandler extends _usergeneralhandler.UserGeneralHandler {
    replaceDelimitedWithKeyValue(param) {
        const { knex, needleColumn, stack } = param;
        return `(${(0, _sqlite3.replaceDelimitedWithKeyValueSqlite3)({
            knex,
            needleColumn,
            stack
        })})`;
    }
    constructor(...args){
        super(...args), this.singleLineTextHandler = new _genericsqlite.GenericSqliteFieldHandler();
    }
};
let UserSqliteHandler = class UserSqliteHandler extends _genericsqlite.GenericSqliteFieldHandler {
    constructor(...args){
        super(...args), this.userHandler = new UserLikeNLikeSqliteHandler(), this.filter = this.userHandler.filter, this.filterLike = this.userHandler.filterLikeNlike, this.filterNlike = this.userHandler.filterLikeNlike, this.parseUserInput = this.userHandler.parseUserInput, this.singleLineTextHandler = this.userHandler.singleLineTextHandler, this.replaceDelimitedWithKeyValue = this.userHandler.replaceDelimitedWithKeyValue;
    }
};
